<template>
  <v-dialog
    v-model="opened"
    content-class="pass-auto"
    max-width="400"
    persistent
  >
    <h3 class="pass-auto__title">{{ $t('mechanic.passAuto') }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="pass-auto" class="pass-auto__form" @submit.prevent="onSubmit">
      <v-autocomplete
        v-model="selectedDriver"
        item-text="phone"
        outlined
        dense
        chips
        deletable-chips
        small-chips
        hide-no-data
        return-object
        :loading="driverLoading"
        :menu-props="{ maxHeight: 200 }"
        :items="foundDrivers"
        :label="$t('autoRents.tableHeaders.phone')"
        :search-input.sync="inputPhone"
      />

      <v-text-field
        outlined
        dense
        readonly
        :value="selectedDriver ? selectedDriver.name : ''"
        :label="$t('autoRents.tableHeaders.driverName')"
      />

      <v-select
        v-model="status"
        outlined
        dense
        item-text="name"
        item-value="id"
        :label="$t('common.fields.status')"
        :items="filteredStatuses"
        :item-disabled="isDisabledStatus"
        :rules="[isRequired]"
        :loading="statusesLoading"
      />

      <v-btn
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    carId: {
      type: [Number, String],
      default: '',
    },
  },
  data: () => ({
    loading: false,
    driverLoading: false,
    statusesLoading: false,
    inputPhone: '',
    selectedDriver: null,
    status: '',
  }),
  watch: {
    inputPhone(val) {
      if (this.selectedDriver) return;
      this.searchDrivers(val);
    },
    opened(val) {
      if (!val) this.$refs['pass-auto'].reset();
    },
  },
  computed: {
    ...mapState({
      foundDrivers: (state) => state['workers-board'].foundDrivers,
      carStatuses: (state) => state['workers-board'].carStatuses,
    }),
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    filteredStatuses() {
      return this.carStatuses.filter(({ id }) => {
        const exceptions = ['0', '5', '8', '9', '11'];
        return !exceptions.includes(id);
      });
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },

    async searchDrivers(value) {
      this.driverLoading = true;
      await this.$store.dispatch('workers-board/searchExistingDrivers', value);
      this.driverLoading = false;
    },

    isDisabledStatus({ id }) {
      let isDriverRequire = false;

      switch (Number(id)) {
        case 1:
        case 5:
        case 8:
        case 9:
        case 11:
        case 13:
          isDriverRequire = true;
          break;
        default:
          isDriverRequire = false;
      }

      return this.selectedDriver ? !isDriverRequire : isDriverRequire;
    },

    async onSubmit() {
      const isValid = this.$refs['pass-auto'].validate();

      if (!isValid) return;

      this.loading = true;

      const params = {
        carId: this.carId,
        status: this.status,
      };

      if (this.selectedDriver) {
        params.driverId = this.selectedDriver.id;
      }

      const response = await this.$store.dispatch('mechanic/passCar', {
        carId: this.carId,
        params,
      });

      if (response.success) {
        this.opened = false;
      }

      this.$emit('updated', response);

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.pass-auto {
  padding: 10px;
  background-color: #fff;

  &__title {
    font-size: 18px;
    color: #424242;
    margin-bottom: 20px;
    margin-top: 3px;
    line-height: 1.2;
  }

  &__form {
    margin-top: 10px;
  }
}
</style>
